import { css } from '@emotion/css';

import { ImageLayoutTypes } from '../types';

export const imageStyles = css`
  @media (max-width: 767px) {
    width: 100% !important;
    left: 0;
    right: 0;
  }
`;

export const imageLayoutStyles = (layout?: string) => {
  switch (layout) {
    case ImageLayoutTypes.Card:
      return css`
        img {
          box-shadow: var(--shadow-02);
          border-radius: 0.4rem;
        }
      `;
    case ImageLayoutTypes.Mobile:
      return css`
        img {
          box-shadow:
            0px -10px 20px rgba(0, 0, 0, 0.04),
            0px 10px 20px rgba(0, 0, 0, 0.04),
            0px 2px 6px rgba(0, 0, 0, 0.04),
            0px 0px 1px rgba(0, 0, 0, 0.04);
          border: 1px solid var(--gray-100);
          border-radius: 3.8rem;
        }
      `;
    case ImageLayoutTypes.Web:
      return css`
        box-shadow:
          0px -10px 20px rgba(0, 0, 0, 0.04),
          0px 10px 20px rgba(0, 0, 0, 0.04),
          0px 2px 6px rgba(0, 0, 0, 0.04),
          0px 0px 1px rgba(0, 0, 0, 0.04);
        border: 1px solid var(--gray-100);
        border-radius: 0.8rem;
        overflow: hidden;
      `;
    case ImageLayoutTypes.None:
    default:
      return css``;
  }
};
